// Autofill functionality for department schedules
// NOTE: This is for internal usage only. Users are meant to use Phoenix frontend, not makeshift-web

// Store last autofill configuration for reconfigure functionality (global scope)
var lastAutofillConfig = null;

// Store current autofill job context for Pusher event filtering and override functionality
var currentAutofillJobId = null;
var currentAutofillDepartmentId = null;

// Pagination state for detailed results
var currentDetailsPage = 1;
var detailsSoftWeights = {};

$(document).on('ready turbolinks:load', function() {
  // Only initialize Pusher listeners on pages with autofill functionality
  // This prevents unnecessary Pusher checks on login page, etc.
  if ($('#autofill-trigger').length > 0) {
    initializePusherListeners();
  }

  // Initialize autofill button click handler
  $(document).on('click', '#autofill-trigger', function(e) {
    e.preventDefault();

    const departmentId = $(this).data('department-id');

    // Read dates from URL params (current schedule view)
    const urlParams = new URLSearchParams(window.location.search);
    let startDate = urlParams.get('start');

    // If no start param in URL, fall back to data attributes
    if (!startDate) {
      startDate = $(this).data('start-date');
    }

    // Strip any surrounding quotes from the date string
    if (startDate && typeof startDate === 'string') {
      startDate = startDate.replace(/^["']|["']$/g, '');
    }

    // Calculate end date (start + 6 days for a week)
    let endDate;
    if (startDate) {
      const start = new Date(startDate);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      endDate = end.toISOString().split('T')[0];
    } else {
      endDate = $(this).data('end-date');
    }

    // Remove any existing modal to ensure fresh content
    $('#autofill-modal').remove();

    // Load the autofill modal
    $.ajax({
      url: `/departments/${departmentId}/autofill_jobs/new`,
      method: 'GET',
      data: {
        start_date: startDate,
        end_date: endDate
      },
      success: function(html) {
        // Create and populate modal
        var $modal = $('<div id="autofill-modal" class="modal hide fade" tabindex="-1" role="dialog"></div>');
        $modal.html(html);
        $('body').append($modal);

        // Show modal
        $modal.modal('show');

        // Initialize optimization toggle
        initializeOptimizationToggle();

        // Initialize form submission handler
        initializeFormSubmission(departmentId);
      },
      error: function(xhr) {
        console.error('[Autofill] Modal load error:', xhr);
        alert('Failed to load autofill modal');
      }
    });
  });

  // Initialize optimization toggle
  // Simplified from slider (0-5) to toggle (off/on)
  // Testing showed depth 1 achieves same results as depths 2-5
  function initializeOptimizationToggle() {
    var $modal = $('#autofill-modal');
    var $toggle = $modal.find('#optimization-enabled');
    var $advancedLookaheadInput = $modal.find('#advanced-lookahead');
    var $labelOff = $modal.find('#optimization-label-off');
    var $labelOn = $modal.find('#optimization-label-on');
    var $container = $modal.find('#lookahead-container');

    if (!$toggle.length) return;

    function updateToggle() {
      var isEnabled = $toggle.prop('checked');

      // Set advanced_lookahead boolean value
      $advancedLookaheadInput.val(isEnabled ? 'true' : 'false');

      // Update label styling and container background
      if (isEnabled) {
        $labelOff.css({ color: '#999', fontWeight: 'normal' });
        $labelOn.css({ color: '#0088cc', fontWeight: '500' });
        $container.css({ background: '#e8f4fc' });
      } else {
        $labelOff.css({ color: '#333', fontWeight: '500' });
        $labelOn.css({ color: '#999', fontWeight: 'normal' });
        $container.css({ background: '#f5f5f5' });
      }
    }

    // Update on change
    $toggle.on('change', updateToggle);

    // Initial update
    updateToggle();
  }

  // Initialize form submission
  function initializeFormSubmission(departmentId) {
    $('#autofill-form').off('ajax:success ajax:error');

    $('#autofill-form').on('ajax:success', function(event, data, status, xhr) {
      // Rails UJS in older jQuery passes data as second parameter, not in event.detail
      // Set job ID from server response for Pusher event filtering
      currentAutofillJobId = data.autofill_job_id;

      // Store the configuration that was just submitted
      lastAutofillConfig = captureAutofillConfig();

      // Show progress modal first (while config modal is still visible)
      showAutofillProgress(data.autofill_job_id, departmentId);

      // Then hide config modal with a slight delay to ensure smooth transition
      setTimeout(function() {
        $('#autofill-modal').modal('hide');
      }, 100);

    }).on('ajax:error', function(event, xhr, status, error) {
      // Rails UJS passes xhr as second parameter
      var data = xhr.responseJSON || {};
      if (data.errors) {
        alert('Error: ' + data.errors.join(', '));
      } else {
        alert('An error occurred while starting autofill');
      }
    });
  }

  // Initialize Pusher listeners for autofill events
  var pusherRetryCount = 0;
  var maxPusherRetries = 10; // Stop retrying after 10 failures

  function initializePusherListeners() {
    if (typeof Pusher === 'undefined' || !window.msPusherChannel) {
      pusherRetryCount++;
      if (pusherRetryCount < maxPusherRetries) {
        // Retry after a short delay to allow Pusher to initialize
        setTimeout(initializePusherListeners, 2000);
      }
      return;
    }

    // Unbind previous listeners to avoid duplicates
    window.msPusherChannel.unbind('autofill.progress');
    window.msPusherChannel.unbind('autofill.success');
    window.msPusherChannel.unbind('autofill.failure');
    window.msPusherChannel.unbind('accept.progress');
    window.msPusherChannel.unbind('accept.success');
    window.msPusherChannel.unbind('accept.failure');

    // Listen for progress updates
    window.msPusherChannel.bind('autofill.progress', function(data) {
      // Only process if this tab has an active job AND the event job matches
      if (!currentAutofillJobId || !data.autofill_job_id) {
        return;
      }

      if (data.autofill_job_id === currentAutofillJobId) {
        updateProgressBar(data.message, data.percent);
      }
    });

    // Listen for autofill success
    window.msPusherChannel.bind('autofill.success', function(data) {
      // Only process if this tab has an active job AND the event job matches
      if (!currentAutofillJobId || !data.autofill_job_id) {
        return;
      }

      if (data.autofill_job_id === currentAutofillJobId) {
        showAutofillResults(data);
      }
    });

    // Listen for autofill failure
    window.msPusherChannel.bind('autofill.failure', function(data) {
      // Only process if this tab has an active job AND the event job matches
      if (!currentAutofillJobId || !data.autofill_job_id) {
        return;
      }

      if (data.autofill_job_id === currentAutofillJobId) {
        $('#autofill-progress-modal').modal('hide').remove();
        const message = `Autofill failed: ${data.error || 'Unknown error'}`;
        alert(message);
        // Clear the job ID since the process is done
        currentAutofillJobId = null;
      }
    });

    // Listen for accept progress updates
    window.msPusherChannel.bind('accept.progress', function(data) {
      if (!currentAutofillJobId || data.autofill_job_id !== currentAutofillJobId) {
        return;
      }
      updateAcceptProgressBar(data.message, data.percent);
    });

    // Listen for accept success
    window.msPusherChannel.bind('accept.success', function(data) {
      if (!currentAutofillJobId || data.autofill_job_id !== currentAutofillJobId) {
        return;
      }
      handleAcceptSuccess(data);
    });

    // Listen for accept failure
    window.msPusherChannel.bind('accept.failure', function(data) {
      if (!currentAutofillJobId || data.autofill_job_id !== currentAutofillJobId) {
        return;
      }
      handleAcceptFailure(data);
    });
  }

  // Show autofill progress modal
  function showAutofillProgress(jobId, departmentId) {
    // Remove any existing progress modal
    $('#autofill-progress-modal').remove();

    var $modal = $('<div id="autofill-progress-modal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">' +
      '<div class="modal-header">' +
        '<h3>Autofill in Progress</h3>' +
      '</div>' +
      '<div class="modal-body">' +
        '<p id="autofill-progress-message">Starting autofill...</p>' +
        '<div class="progress progress-striped active">' +
          '<div id="autofill-progress-bar" class="bar" style="width: 0%"></div>' +
        '</div>' +
      '</div>' +
    '</div>');

    $modal.data('job-id', jobId);
    $modal.data('department-id', departmentId);

    $('body').append($modal);

    $modal.modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  // Update progress bar
  function updateProgressBar(message, percent) {
    $('#autofill-progress-message').text(message);
    $('#autofill-progress-bar').css('width', percent + '%');
  }

  // Fetch autofill details via AJAX (paginated)
  function fetchAutofillDetails(jobId, departmentId, page) {
    page = page || 1;
    currentAutofillJobId = jobId;
    currentAutofillDepartmentId = departmentId;

    // Show loading indicator
    if (page === 1) {
      $('#autofill-details-container').html('<p style="text-align: center; color: #999;">Loading detailed results...</p>');
    } else {
      $('#prev-page-btn, #next-page-btn').prop('disabled', true);
      $('#results-list-container').css('opacity', '0.5');
    }

    $.ajax({
      url: '/departments/' + departmentId + '/autofill_jobs/' + jobId + '?page=' + page + '&per_page=200',
      method: 'GET',
      dataType: 'json',
      success: function(response) {
        currentDetailsPage = page;
        detailsSoftWeights = response.soft_weights || {};
        if (page === 1) {
          var detailsHtml = buildDetailedResults(response);
          $('#autofill-details-container').html(detailsHtml);
        } else {
          replaceDetailedResults(response);
        }
        // Update button states after DOM is updated
        if (response.pagination) {
          updatePaginationButtons(response.pagination);
        }
      },
      error: function(xhr) {
        console.error('[Autofill] Failed to fetch details:', xhr);
        if (page === 1) {
          $('#autofill-details-container').html(
            '<p style="text-align: center; color: #d9534f;">Failed to load detailed results. Please try again.</p>'
          );
        } else {
          $('#results-list-container').css('opacity', '1');
          $('#prev-page-btn').prop('disabled', currentDetailsPage <= 1);
          $('#next-page-btn').prop('disabled', false);
        }
      }
    });
  }

  // Build detailed results HTML
  function buildDetailedResults(data) {
    var assignments = data.assignments || [];
    var unfilled = data.unfilled || [];
    var softWeights = data.soft_weights || {};
    var pagination = data.pagination || {};

    var totalCount = pagination.total_count || (assignments.length + unfilled.length);
    var currentPage = pagination.current_page || 1;
    var perPage = pagination.per_page || 200;
    var startItem = (currentPage - 1) * perPage + 1;
    var endItem = Math.min(currentPage * perPage, totalCount);

    if (assignments.length === 0 && unfilled.length === 0 && totalCount === 0) {
      return '';
    }

    var html = '<div class="autofill-details" style="margin-top: 20px;">' +
      '<h4 style="cursor: pointer;" id="toggle-details">' +
        '<i class="icon-chevron-right"></i> View Detailed Results (' + totalCount.toLocaleString() + ')' +
      '</h4>' +
      '<div id="autofill-details-content" style="display: none; max-height: calc(100vh - 400px); overflow-y: auto; margin-top: 10px;">' +
      '<div id="results-list-container">';

    // Build results HTML
    html += buildResultsListHtml(assignments, unfilled, softWeights);

    html += '</div>'; // close results-list-container

    // Add pagination controls if there are multiple pages
    if (pagination.total_pages > 1) {
      html += buildPaginationControls(pagination, startItem, endItem, totalCount);
    }

    html += '</div></div>';
    return html;
  }

  // Build pagination controls
  function buildPaginationControls(pagination, startItem, endItem, totalCount) {
    var html = '<div id="pagination-container" style="text-align: center; padding: 15px; border-top: 1px solid #eee;">' +
      '<div style="margin-bottom: 8px; color: #666;">Showing ' + startItem + '-' + endItem + ' of ' + totalCount.toLocaleString() + '</div>' +
      '<button type="button" class="btn" id="prev-page-btn" style="margin-right: 10px;">' +
        '&larr; Previous Page' +
      '</button>' +
      '<button type="button" class="btn" id="next-page-btn">' +
        'Next Page &rarr;' +
      '</button>' +
    '</div>';

    return html;
  }

  // Update pagination button states based on current page
  function updatePaginationButtons(pagination) {
    if (!pagination) return;

    $('#prev-page-btn').prop('disabled', pagination.current_page <= 1);
    $('#next-page-btn').prop('disabled', pagination.current_page >= pagination.total_pages);
  }

  // Build HTML for a list of results (used by both initial load and append)
  function buildResultsListHtml(assignments, unfilled, softWeights) {
    var html = '';

    // Group assignments by date
    var assignmentsByDate = {};
    assignments.forEach(function(assignment) {
      var date = assignment.date;
      if (!assignmentsByDate[date]) {
        assignmentsByDate[date] = [];
      }
      assignmentsByDate[date].push(assignment);
    });

    // Group unfilled by date
    var unfilledByDate = {};
    unfilled.forEach(function(item) {
      var date = item.date;
      if (!unfilledByDate[date]) {
        unfilledByDate[date] = [];
      }
      unfilledByDate[date].push(item);
    });

    // Get all dates and sort
    var allDates = Object.keys(assignmentsByDate).concat(Object.keys(unfilledByDate));
    allDates = Array.from(new Set(allDates)).sort();

    // Build HTML for each date
    allDates.forEach(function(date) {
      var dateObj = new Date(date + 'T00:00:00');
      var dateStr = dateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

      html += '<div class="date-section" data-date="' + date + '" style="margin-bottom: 20px;">' +
        '<h5 style="background: #f5f5f5; padding: 8px; margin: 10px 0 5px 0;">' + dateStr + '</h5>';

      // Show filled assignments
      if (assignmentsByDate[date]) {
        assignmentsByDate[date].forEach(function(assignment) {
          html += buildAssignmentRow(assignment, softWeights);
        });
      }

      // Show unfilled
      if (unfilledByDate[date]) {
        unfilledByDate[date].forEach(function(item) {
          html += buildUnfilledRow(item);
        });
      }

      html += '</div>';
    });

    return html;
  }

  // Replace results with new page
  function replaceDetailedResults(data) {
    var assignments = data.assignments || [];
    var unfilled = data.unfilled || [];
    var pagination = data.pagination || {};

    var totalCount = pagination.total_count || 0;
    var currentPage = pagination.current_page || 1;
    var perPage = pagination.per_page || 200;
    var startItem = (currentPage - 1) * perPage + 1;
    var endItem = Math.min(currentPage * perPage, totalCount);

    // Replace results and restore opacity
    var newHtml = buildResultsListHtml(assignments, unfilled, detailsSoftWeights);
    $('#results-list-container').html(newHtml).css('opacity', '1');

    // Update pagination controls
    if (pagination.total_pages > 1) {
      var paginationHtml = buildPaginationControls(pagination, startItem, endItem, totalCount);
      $('#pagination-container').replaceWith(paginationHtml);
    } else {
      $('#pagination-container').remove();
    }

    // Scroll to top of results
    $('#autofill-details-content').scrollTop(0);
  }

  // Build HTML for a single assignment
  function buildAssignmentRow(assignment, softWeights) {
    softWeights = softWeights || {};
    // Use pre-formatted times from backend (in department timezone)
    var startTime = assignment.formatted_start_time || new Date(assignment.starts_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    var endTime = assignment.formatted_end_time || new Date(assignment.ends_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

    var slotNumber = assignment.slot_number || 1;
    var totalSlots = assignment.total_slots || 1;
    var slotDisplay = totalSlots > 1 ? ' (' + slotNumber + '/' + totalSlots + ')' : '';

    var details = [];
    if (assignment.position_name) details.push(assignment.position_name);
    if (assignment.job_site_name) details.push(assignment.job_site_name);

    // Reasons come from backend as structured object
    var reasons = assignment.reasons || {};
    var selection = reasons.selection || {};
    var candidateCount = selection.candidate_count || 1;
    var winningFactors = selection.winning_factors || [];
    var candidates = selection.candidates || [];
    var randomSelection = selection.random_selection || false;
    var selectionReason = selection.selection_reason || '';
    var seed = selection.seed;

    // Build the "Qualifies" line (hard constraints met)
    var qualifiesReason = reasons.qualifies_reason || '';
    var qualifiesHtml = qualifiesReason
      ? '<div style="margin-top: 5px; font-size: 12px; color: #666;"><strong>Qualifies:</strong> ' + qualifiesReason + '</div>'
      : '';

    // Build the "Selected because" line (why they won over other candidates)
    var selectedHtml = '';
    if (candidateCount === 1) {
      selectedHtml = '<div style="margin-top: 3px; font-size: 12px; color: #888;"><em>' + selectionReason + '</em></div>';
    } else if (randomSelection) {
      selectedHtml = '<div style="margin-top: 3px; font-size: 12px; color: #337ab7;" title="Random seed: ' + seed + '"><strong>' + selectionReason + '</strong></div>';
    } else if (winningFactors.length > 0) {
      selectedHtml = '<div style="margin-top: 3px; font-size: 12px; color: #5cb85c;"><strong>Selected because:</strong> ' + selectionReason + '</div>';
    } else {
      selectedHtml = '<div style="margin-top: 3px; font-size: 12px; color: #888;"><em>' + selectionReason + '</em></div>';
    }

    // Build candidates table (all qualified employees with their stats)
    var candidatesHtml = '';
    var isLocked = assignment.locked || false;
    if (candidates.length >= 1) {
      // Determine which columns are active (weight > 0)
      var costActive = parseInt(softWeights.cost || 0, 10) > 0;
      var fairnessActive = parseInt(softWeights.fairness || 0, 10) > 0;
      var seniorityActive = parseInt(softWeights.seniority || 0, 10) > 0;
      var employmentTypeActive = parseInt(softWeights.employment_type || 0, 10) > 0;

      // Styles for inactive columns
      var inactiveHeaderStyle = 'color: #999; cursor: help;';
      var inactiveCellStyle = 'color: #ababab;';

      // Build header labels with tooltip when inactive
      var wageHeader = costActive ? 'Wage' : '<span style="' + inactiveHeaderStyle + '" title="Not used in scoring">Wage</span>';
      var hoursHeader = fairnessActive ? 'Hours' : '<span style="' + inactiveHeaderStyle + '" title="Not used in scoring">Hours</span>';
      var tenureHeader = seniorityActive ? 'Tenure' : '<span style="' + inactiveHeaderStyle + '" title="Not used in scoring">Tenure</span>';
      var typeHeader = employmentTypeActive ? 'Type' : '<span style="' + inactiveHeaderStyle + '" title="Not used in scoring">Type</span>';

      candidatesHtml = '<div style="margin-top: 8px; font-size: 11px;">' +
        '<div style="color: #666; margin-bottom: 4px;"><strong>All qualified candidates (' + candidates.length + '):</strong></div>' +
        '<table style="width: 100%; font-size: 11px; border-collapse: collapse;">' +
          '<thead>' +
            '<tr style="background: #eee; text-align: left;">' +
              '<th style="padding: 4px 6px;">Employee</th>' +
              '<th style="padding: 4px 8px; min-width: 50px;">' + wageHeader + '</th>' +
              '<th style="padding: 4px 6px;">' + hoursHeader + '</th>' +
              '<th style="padding: 4px 6px;">' + tenureHeader + '</th>' +
              '<th style="padding: 4px 6px;">' + typeHeader + '</th>' +
              '<th style="padding: 4px 6px;">Score</th>' +
              '<th style="padding: 4px 6px;"></th>' +
            '</tr>' +
          '</thead>' +
          '<tbody>';

      candidates.forEach(function(candidate) {
        var rowStyle = candidate.selected
          ? 'background: #dff0d8; font-weight: bold;'
          : '';
        var stats = candidate.stats || {};

        // Build action column - Override button for non-selected, Lock indicator for selected
        var actionHtml = '';
        if (candidate.selected) {
          if (isLocked) {
            actionHtml = '<span style="color: #f0ad4e;" title="This assignment is locked">🔒</span>';
          } else {
            actionHtml = '<span style="color: #5cb85c;">✓</span>';
          }
        } else {
          actionHtml = '<button type="button" class="btn btn-mini select-btn" ' +
            'data-shift-requirement-id="' + assignment.shift_requirement_id + '" ' +
            'data-user-id="' + candidate.user_id + '" ' +
            'data-user-name="' + candidate.user_name + '" ' +
            'data-current-user-id="' + assignment.user_id + '" ' +
            'data-slot-number="' + slotNumber + '" ' +
            'data-total-slots="' + totalSlots + '" ' +
            'data-position-name="' + (assignment.position_name || '') + '" ' +
            'data-time-range="' + startTime + ' - ' + endTime + '" ' +
            'style="padding: 1px 6px; font-size: 10px; white-space: nowrap;">Select</button>';
        }

        var scoreDisplay = (typeof candidate.score === 'number') ? candidate.score.toFixed(2) : candidate.score;

        // Apply inactive styling to cell values when weight is off
        var wageValue = stats.hourly_rate || '-';
        var hoursValue = stats.past_hours_display || '-';
        var tenureValue = stats.tenure_display || '-';
        var typeValue = stats.employment_type || '-';

        if (!costActive) wageValue = '<span style="' + inactiveCellStyle + '">' + wageValue + '</span>';
        if (!fairnessActive) hoursValue = '<span style="' + inactiveCellStyle + '">' + hoursValue + '</span>';
        if (!seniorityActive) tenureValue = '<span style="' + inactiveCellStyle + '">' + tenureValue + '</span>';
        if (!employmentTypeActive) typeValue = '<span style="' + inactiveCellStyle + '">' + typeValue + '</span>';

        candidatesHtml += '<tr style="' + rowStyle + '">' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd;">' +
            (candidate.selected ? '★ ' : '') + candidate.user_name +
          '</td>' +
          '<td style="padding: 4px 8px; border-bottom: 1px solid #ddd;">' +
            wageValue +
          '</td>' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd;">' +
            hoursValue +
          '</td>' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd;">' +
            tenureValue +
          '</td>' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd;">' +
            typeValue +
          '</td>' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd;">' +
            scoreDisplay +
          '</td>' +
          '<td style="padding: 4px 6px; border-bottom: 1px solid #ddd; text-align: center;">' +
            actionHtml +
          '</td>' +
        '</tr>';
      });

      candidatesHtml += '</tbody></table></div>';
    }

    // Build collapsible qualification info section
    var qualificationInfoHtml = '';
    if (qualifiesHtml || selectedHtml || candidatesHtml) {
      var uniqueId = 'qual-' + assignment.shift_requirement_id + '-' + assignment.user_id;
      qualificationInfoHtml = '<div style="margin-top: 8px;">' +
        '<div class="qualification-toggle" data-target="' + uniqueId + '" style="cursor: pointer; font-size: 12px; color: #337ab7;">' +
          '<i class="icon-chevron-right"></i> <strong>Qualification Info</strong>' +
        '</div>' +
        '<div id="' + uniqueId + '" class="qualification-content" style="display: none; margin-top: 5px; padding-left: 10px; border-left: 2px solid #ddd;">' +
          qualifiesHtml +
          selectedHtml +
          candidatesHtml +
        '</div>' +
      '</div>';
    }

    return '<div class="assignment-row" style="padding: 10px; border-left: 3px solid #5cb85c; margin-bottom: 10px; background: #f9f9f9;">' +
      '<div style="display: flex; justify-content: space-between; align-items: start;">' +
        '<div style="flex: 1;">' +
          '<strong style="color: #5cb85c;">✓ Filled</strong> ' +
          '<span style="color: #666;">' + startTime + ' - ' + endTime + '</span>' +
          (details.length > 0 ? ' <span style="color: #999;">| ' + details.join(' | ') + '</span>' : '') +
          '<span style="color: #999;">' + slotDisplay + '</span>' +
        '</div>' +
      '</div>' +
      '<div style="margin-top: 5px;">' +
        '<strong>Assigned to:</strong> ' + assignment.user_name +
        (isLocked ? ' <span style="color: #f0ad4e; margin-left: 5px;" title="This assignment is locked">🔒</span>' : '') +
      '</div>' +
      qualificationInfoHtml +
    '</div>';
  }

  // Build HTML for an unfilled requirement
  function buildUnfilledRow(item) {
    // Use pre-formatted times from backend (in department timezone)
    var startTime = item.formatted_start_time || new Date(item.starts_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    var endTime = item.formatted_end_time || new Date(item.ends_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

    var details = [];
    if (item.position_name) details.push(item.position_name);
    if (item.job_site_name) details.push(item.job_site_name);

    var stillNeeded = item.still_needed || 0;
    var slotsToFill = item.slots_to_fill || item.required_employees;

    // Use the pre-computed reason from backend (based on eligibility funnel)
    var whyMessage = item.reason || 'Unable to find eligible employees';

    return '<div class="unfilled-row" style="padding: 10px; border-left: 3px solid #d9534f; margin-bottom: 10px; background: #fef5f5;">' +
      '<div style="display: flex; justify-content: space-between; align-items: start;">' +
        '<div style="flex: 1;">' +
          '<strong style="color: #d9534f;">✗ Unfilled</strong> ' +
          '<span style="color: #666;">' + startTime + ' - ' + endTime + '</span>' +
          (details.length > 0 ? ' <span style="color: #999;">| ' + details.join(' | ') + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<div style="margin-top: 5px;">' +
        '<strong>Could not fill:</strong> ' + stillNeeded + ' of ' + slotsToFill +
      '</div>' +
      '<div style="margin-top: 5px; font-size: 12px; color: #666;"><strong>Why:</strong> ' + whyMessage + '</div>' +
    '</div>';
  }

  // Show autofill results modal
  function showAutofillResults(data) {
    // Store job context for override functionality
    currentAutofillJobId = data.autofill_job_id;
    currentAutofillDepartmentId = data.department_id;

    var stats = data.stats || {};
    var successRate = data.success_rate || 0;
    var filledCount = stats.filled_count || 0;
    var unfilledCount = stats.unfilled_count || 0;

    // Convert total_cost to number (it comes as BigDecimal string from Rails)
    var totalCost = parseFloat(stats.total_cost || 0);
    var processingTime = parseFloat(stats.processing_time_seconds || 0);

    // Algorithm metrics
    var lookaheadSimulations = stats.lookahead_simulations || 0;
    var constraintChecks = stats.constraint_checks || 0;

    // Build constraint checks summary
    var constraintInfo = '';
    if (constraintChecks > 0) {
      constraintInfo = ' · ' + constraintChecks.toLocaleString() + ' checks';
      if (lookaheadSimulations > 0) {
        constraintInfo += ' (' + lookaheadSimulations.toLocaleString() + ' simulations)';
      }
    }

    // Remove any existing results modal and clean up its backdrop to prevent duplicates
    var $existingResultsModal = $('#autofill-results-modal');
    if ($existingResultsModal.length > 0) {
      // Hide modal first to trigger Bootstrap's cleanup, then remove
      $existingResultsModal.modal('hide');
      $existingResultsModal.remove();
      // Only remove backdrops if we just removed an existing results modal
      // (this handles the override case where backdrop would otherwise duplicate)
      $('.modal-backdrop').remove();
    }

    var alertClass = filledCount > 0 ? 'alert-success' : 'alert-info';

    var $modal = $('<div id="autofill-results-modal" class="modal hide fade" role="dialog" style="width: 650px; max-height: 85vh; display: flex; flex-direction: column;">' +
      '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h3>Autofill Complete</h3>' +
      '</div>' +
      '<div class="modal-body" style="flex: 1; min-height: 0; overflow-y: auto;">' +
        '<div class="alert ' + alertClass + '">' +
          '<h4 style="margin-top: 5px; margin-bottom: 7px;">Results Summary</h4>' +
          '<p><strong>Fill Rate:</strong> ' + successRate + '% · ' +
          '<strong>Filled:</strong> ' + filledCount + ' shifts · ' +
          '<strong>Unfilled:</strong> ' + unfilledCount + ' shifts</p>' +
          '<p><strong>Total Cost:</strong> $' + totalCost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' · <strong>Processing Time:</strong> ' + processingTime.toFixed(2) + 's' + constraintInfo + '</p>' +
        '</div>' +
        (filledCount > 0 ?
          '<p>Click "Create Shifts" to add these shifts to the schedule (they will be unpublished).</p>' :
          '<p>No shifts could be assigned. Check that employees have the required positions and no conflicting shifts.</p>') +
        '<div id="autofill-details-container">' +
          '<p style="text-align: center; color: #999;">Loading detailed results...</p>' +
        '</div>' +
      '</div>' +
      '<div class="modal-footer">' +
        '<button type="button" class="btn" data-dismiss="modal">Close</button>' +
        '<button type="button" class="btn" id="reconfigure-autofill-btn" data-department-id="' + data.department_id + '">Reconfigure</button>' +
        (filledCount > 0 ?
          '<button type="button" class="btn btn-primary" id="accept-autofill-btn" data-job-id="' + data.autofill_job_id + '" data-department-id="' + data.department_id + '">Create Shifts</button>' :
          '') +
      '</div>' +
    '</div>');

    // Fetch full details via AJAX
    fetchAutofillDetails(data.autofill_job_id, data.department_id);

    $('body').append($modal);

    // Hide progress modal first, then show results modal
    var $progressModal = $('#autofill-progress-modal');

    if ($progressModal.length > 0) {
      // Wait for progress modal to finish hiding before showing results
      $progressModal.on('hidden', function() {
        $(this).remove();
        $modal.modal('show');
      });
      $progressModal.modal('hide');
    } else {
      // No progress modal, just show results
      $modal.modal('show');
    }

    // Handle accept button
    $('#accept-autofill-btn').off('click').on('click', function() {
      var jobId = $(this).data('job-id');
      var departmentId = $(this).data('department-id');
      acceptAutofillResults(jobId, departmentId);
    });

    // Handle reconfigure button
    $('#reconfigure-autofill-btn').off('click').on('click', function() {
      var departmentId = $(this).data('department-id');

      // Close results modal
      $('#autofill-results-modal').modal('hide').remove();

      // Reopen configuration modal with same dates
      reopenAutofillConfiguration(departmentId);
    });

    // Handle toggle details using event delegation (since the element is loaded via AJAX)
    $(document).off('click', '#toggle-details').on('click', '#toggle-details', function() {
      var $icon = $(this).find('i');
      var $content = $('#autofill-details-content');

      if ($content.is(':visible')) {
        $content.slideUp();
        $icon.removeClass('icon-chevron-down').addClass('icon-chevron-right');
      } else {
        $content.slideDown();
        $icon.removeClass('icon-chevron-right').addClass('icon-chevron-down');
      }
    });

    // Handle Previous Page button click
    $(document).off('click', '#prev-page-btn').on('click', '#prev-page-btn', function() {
      if (currentDetailsPage > 1) {
        fetchAutofillDetails(currentAutofillJobId, currentAutofillDepartmentId, currentDetailsPage - 1);
      }
    });

    // Handle Next Page button click
    $(document).off('click', '#next-page-btn').on('click', '#next-page-btn', function() {
      fetchAutofillDetails(currentAutofillJobId, currentAutofillDepartmentId, currentDetailsPage + 1);
    });

    // Handle qualification info toggle using event delegation
    $(document).off('click', '.qualification-toggle').on('click', '.qualification-toggle', function() {
      var $icon = $(this).find('i');
      var targetId = $(this).data('target');
      var $content = $('#' + targetId);

      if ($content.is(':visible')) {
        $content.slideUp();
        $icon.removeClass('icon-chevron-down').addClass('icon-chevron-right');
      } else {
        $content.slideDown();
        $icon.removeClass('icon-chevron-right').addClass('icon-chevron-down');
      }
    });

    // Handle select button clicks using event delegation
    $(document).off('click', '.select-btn').on('click', '.select-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var $btn = $(this);
      var shiftRequirementId = $btn.data('shift-requirement-id');
      var userId = $btn.data('user-id');
      var userName = $btn.data('user-name');
      var currentUserId = $btn.data('current-user-id');
      var slotNumber = $btn.data('slot-number') || 1;
      var totalSlots = $btn.data('total-slots') || 1;
      var positionName = $btn.data('position-name') || '';
      var timeRange = $btn.data('time-range') || '';

      var slotInfo = totalSlots > 1 ? ' (slot ' + slotNumber + ' of ' + totalSlots + ')' : '';
      var shiftInfo = timeRange + (positionName ? ' | ' + positionName : '') + slotInfo;

      if (confirm('Select ' + userName + ' for this shift?\n\nShift: ' + shiftInfo + '\n\nThis will lock them in and re-run assignments for other affected shifts.')) {
        overrideAssignment(shiftRequirementId, userId, currentUserId, $btn);
      }
    });
  }

  // Override an assignment with a different user
  function overrideAssignment(shiftRequirementId, userId, replaceUserId, $btn) {
    if (!currentAutofillJobId || !currentAutofillDepartmentId) {
      console.error('[Autofill] No job context available for override');
      alert('Unable to select: missing job context');
      return;
    }

    // Disable the button and show loading state
    $btn.prop('disabled', true).text('Selecting...');

    $.ajax({
      url: '/departments/' + currentAutofillDepartmentId + '/autofill_jobs/' + currentAutofillJobId + '/override',
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: {
        shift_requirement_id: shiftRequirementId,
        user_id: userId,
        replace_user_id: replaceUserId
      },
      success: function(response) {
        // Refresh the detailed results
        fetchAutofillDetails(currentAutofillJobId, currentAutofillDepartmentId);

        // Update the summary stats if provided
        if (response.stats) {
          updateResultsSummary(response.stats, response.success_rate);
        }
      },
      error: function(xhr) {
        console.error('[Autofill] Override failed:', xhr);
        var data = xhr.responseJSON || {};
        var errorMsg = data.error || 'Failed to select employee';
        alert('Error: ' + errorMsg);
        $btn.prop('disabled', false).text('Select');
      }
    });
  }

  // Update the results summary after an override - rebuild the entire summary section
  function updateResultsSummary(stats, successRate) {
    var $modal = $('#autofill-results-modal');
    if (!$modal.length) return;

    var filledCount = stats.filled_count || 0;
    var unfilledCount = stats.unfilled_count || 0;
    var totalCost = parseFloat(stats.total_cost || 0);
    var alertClass = filledCount > 0 ? 'alert-success' : 'alert-info';

    // Rebuild the entire summary alert
    var summaryHtml = '<div class="alert ' + alertClass + '">' +
      '<h4 style="margin-top: 5px; margin-bottom: 7px;">Results Summary</h4>' +
      '<p><strong>Fill Rate:</strong> ' + successRate + '% · ' +
      '<strong>Filled:</strong> ' + filledCount + ' shifts · ' +
      '<strong>Unfilled:</strong> ' + unfilledCount + ' shifts</p>' +
      '<p><strong>Total Cost:</strong> $' + totalCost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '</p>' +
    '</div>';

    // Replace the existing alert
    $modal.find('.modal-body .alert').replaceWith(summaryHtml);
  }

  // Capture current autofill configuration
  function captureAutofillConfig() {
    var config = {
      // Date range
      start_date: $('#autofill-start-date').val(),
      end_date: $('#autofill-end-date').val(),

      // Specific shift requirements (if selected)
      specific_shifts_enabled: $('#toggle-specific-shifts').prop('checked'),
      shift_requirement_ids: [],

      // Hard constraints
      hard_constraints: {
        no_overlap: $('#no-overlap-checkbox').prop('checked'),
        include_unpublished_in_overlap: $('#include-unpublished-checkbox').prop('checked'),
        respect_employee_availability: $('#respect-availability-checkbox').prop('checked'),
        respect_employee_time_off: $('#respect-time-off-checkbox').prop('checked'),
        require_specific_skills: $('#require-skills-checkbox').prop('checked'),
        respect_fatigue_rules: $('#respect-fatigue-rules-checkbox').prop('checked'),
        respect_weekly_budget: $('#respect-weekly-budget-checkbox').prop('checked'),
        employment_type: {
          full_time: $('#employment-type-full-time').prop('checked'),
          part_time: $('#employment-type-part-time').prop('checked'),
          casual: $('#employment-type-casual').prop('checked')
        }
      },

      // Soft weights (slider values: 0=Off, 1-10=priority level)
      soft_weights: {
        cost: $('input[name="autofill_job[config][soft_weights][cost]"]').val(),
        fairness: $('input[name="autofill_job[config][soft_weights][fairness]"]').val(),
        seniority: $('input[name="autofill_job[config][soft_weights][seniority]"]').val()
      },

      // Fairness options
      fairness_options: {
        time_period: $('#fairness-time-period').val(),
        count_unpublished: $('#fairness-count-unpublished').prop('checked')
      },

      // Algorithm settings
      algorithm_settings: {
        seed: $('#autofill_job_config_algorithm_settings_seed').val(),
        // Boolean flag for advanced lookahead optimization
        advanced_lookahead: $('#optimization-enabled').prop('checked')
      }
    };

    // Capture selected shift requirements if enabled
    if (config.specific_shifts_enabled) {
      $('.requirement-checkbox:checked').each(function() {
        config.shift_requirement_ids.push($(this).val());
      });
    }

    return config;
  }

  // Restore autofill configuration to form
  function restoreAutofillConfig(config) {
    if (!config) return;

    // Restore date range
    if (config.start_date) $('#autofill-start-date').val(config.start_date);
    if (config.end_date) $('#autofill-end-date').val(config.end_date);

    // Restore specific shifts selection
    if (config.specific_shifts_enabled) {
      $('#toggle-specific-shifts').prop('checked', true);
      $('#shift-requirements-section').show();

      // Uncheck all first, then check only the saved ones
      $('.requirement-checkbox').prop('checked', false);
      config.shift_requirement_ids.forEach(function(id) {
        $('.requirement-checkbox[value="' + id + '"]').prop('checked', true);
      });

      // Update select-all checkbox state
      var total = $('.requirement-checkbox').length;
      var checked = $('.requirement-checkbox:checked').length;
      $('#select-all-requirements').prop('checked', total > 0 && total === checked);
    } else {
      // Toggle is off - ensure default state (all checked)
      $('#toggle-specific-shifts').prop('checked', false);
      $('#shift-requirements-section').hide();
      $('.requirement-checkbox').prop('checked', true);
      $('#select-all-requirements').prop('checked', true);
    }

    // Trigger change event to update shift count display
    $('.requirement-checkbox').first().trigger('change');

    // Restore hard constraints
    if (config.hard_constraints) {
      $('#no-overlap-checkbox').prop('checked', config.hard_constraints.no_overlap);
      $('#include-unpublished-checkbox').prop('checked', config.hard_constraints.include_unpublished_in_overlap);
      $('#respect-availability-checkbox').prop('checked', config.hard_constraints.respect_employee_availability);
      $('#respect-time-off-checkbox').prop('checked', config.hard_constraints.respect_employee_time_off);
      $('#require-skills-checkbox').prop('checked', config.hard_constraints.require_specific_skills);
      $('#respect-fatigue-rules-checkbox').prop('checked', config.hard_constraints.respect_fatigue_rules);
      $('#respect-weekly-budget-checkbox').prop('checked', config.hard_constraints.respect_weekly_budget);

      // Show/hide the sub-options based on no_overlap state
      if (config.hard_constraints.no_overlap) {
        $('#overlap-sub-options').show();
      } else {
        $('#overlap-sub-options').hide();
      }
    }

    // Restore soft weights (slider values: 0=Off, 1-10=priority level)
    if (config.soft_weights) {
      $('input[name="autofill_job[config][soft_weights][fairness]"]').val(config.soft_weights.fairness || '5').trigger('input');
      $('input[name="autofill_job[config][soft_weights][cost]"]').val(config.soft_weights.cost || '0').trigger('input');
      $('input[name="autofill_job[config][soft_weights][seniority]"]').val(config.soft_weights.seniority || '0').trigger('input');
    }

    // Restore employment type hard constraint checkboxes
    if (config.hard_constraints && config.hard_constraints.employment_type) {
      $('#employment-type-full-time').prop('checked', config.hard_constraints.employment_type.full_time || false);
      $('#employment-type-part-time').prop('checked', config.hard_constraints.employment_type.part_time || false);
      $('#employment-type-casual').prop('checked', config.hard_constraints.employment_type.casual || false);
    }

    // Restore fairness options
    if (config.fairness_options) {
      $('#fairness-time-period').val(config.fairness_options.time_period || '7');
      $('#fairness-count-unpublished').prop('checked', config.fairness_options.count_unpublished || false);
    }

    // Restore algorithm settings
    if (config.algorithm_settings) {
      $('#autofill_job_config_algorithm_settings_seed').val(config.algorithm_settings.seed || '');
      // Restore optimization toggle state from advanced_lookahead
      var advancedLookahead = config.algorithm_settings.advanced_lookahead;
      if (advancedLookahead !== undefined) {
        $('#optimization-enabled').prop('checked', advancedLookahead).trigger('change');
      }
    }
  }

  // Reopen autofill configuration modal
  function reopenAutofillConfiguration(departmentId) {
    // Use stored dates if available, otherwise read from URL
    let startDate, endDate;

    if (lastAutofillConfig && lastAutofillConfig.start_date && lastAutofillConfig.end_date) {
      // Use the dates from the last configuration
      startDate = lastAutofillConfig.start_date;
      endDate = lastAutofillConfig.end_date;
    } else {
      // Read dates from URL params (current schedule view)
      const urlParams = new URLSearchParams(window.location.search);
      startDate = urlParams.get('start');

      // If no start param in URL, try to get from current autofill button
      if (!startDate) {
        const $autofillTrigger = $('#autofill-trigger');
        if ($autofillTrigger.length) {
          startDate = $autofillTrigger.data('start-date');
        }
      }

      // Strip any surrounding quotes from the date string
      if (startDate && typeof startDate === 'string') {
        startDate = startDate.replace(/^["']|["']$/g, '');
      }

      // Calculate end date (start + 6 days for a week)
      if (startDate) {
        const start = new Date(startDate);
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        endDate = end.toISOString().split('T')[0];
      } else {
        // Fall back to default if no dates found
        const today = new Date();
        const monday = new Date(today);
        monday.setDate(today.getDate() - today.getDay() + 1);
        startDate = monday.toISOString().split('T')[0];

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        endDate = sunday.toISOString().split('T')[0];
      }
    }

    // Remove any existing modal to ensure fresh content
    $('#autofill-modal').remove();

    // Load the autofill modal
    $.ajax({
      url: `/departments/${departmentId}/autofill_jobs/new`,
      method: 'GET',
      data: {
        start_date: startDate,
        end_date: endDate
      },
      success: function(html) {
        // Create and populate modal
        var $modal = $('<div id="autofill-modal" class="modal hide fade" tabindex="-1" role="dialog"></div>');
        $modal.html(html);
        $('body').append($modal);

        // Show modal
        $modal.modal('show');

        // Initialize optimization toggle (must be done before restoring config)
        initializeOptimizationToggle();

        // Restore previous configuration after modal is shown and go to step 3
        setTimeout(function() {
          if (lastAutofillConfig) {
            restoreAutofillConfig(lastAutofillConfig);
          }
          // Ensure steps and Run Autofill button are visible/enabled
          // (in case the initial load had issues)
          var hasRequirements = $('.requirement-checkbox').length > 0;
          if (hasRequirements) {
            $('#autofill-steps-container').show();
            $('#shift-requirements-count').show();
            $('#no-requirements-message').hide();
            $('.specific-shifts-toggle').show();
            $('#run-autofill').prop('disabled', false);
          }
          // Navigate to step 3 (Prioritization)
          $('.step-clickable[data-step="3"]').trigger('click');
        }, 100);

        // Initialize form submission handler
        initializeFormSubmission(departmentId);
      },
      error: function(xhr) {
        console.error('[Autofill] Modal reload error:', xhr);
        alert('Failed to reload autofill modal');
      }
    });
  }

  // Accept autofill results and create shifts (async)
  function acceptAutofillResults(jobId, departmentId) {
    $('#accept-autofill-btn').prop('disabled', true).text('Creating shifts...');

    $.ajax({
      url: '/departments/' + departmentId + '/autofill_jobs/' + jobId + '/accept',
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(data) {
        if (data.async) {
          // Show accept progress modal for async processing
          showAcceptProgress(jobId, departmentId, data.message);
        } else {
          // Synchronous completion (fallback)
          $('#autofill-results-modal').modal('hide').remove();
          alert(data.message || 'Shifts created successfully!');
          currentAutofillJobId = null;
          setTimeout(function() {
            location.reload();
          }, 500);
        }
      },
      error: function(xhr) {
        console.error('[Autofill] Error accepting results:', xhr);
        var data = xhr.responseJSON || {};
        var errorMsg = data.error || data.errors || 'Failed to create shifts';
        if (Array.isArray(errorMsg)) {
          errorMsg = errorMsg.join(', ');
        }
        alert(errorMsg);
        $('#accept-autofill-btn').prop('disabled', false).text('Create Shifts');
      }
    });
  }

  // Timeout ID for accept progress fallback
  var acceptProgressTimeoutId = null;
  var ACCEPT_TIMEOUT_MS = 30000;

  // Helper function for accept progress timeout callback
  function handleAcceptTimeout() {
    var $resultsModal = $('#autofill-results-modal');
    if ($resultsModal.find('.autofill-accept-overlay').length) {
      console.error('[Autofill] Accept progress timeout - no response received');
      handleAcceptFailure({ error: 'Request timed out. Please check server status.' });
    }
  }

  // Show accept progress inside the results modal
  function showAcceptProgress(jobId, departmentId, message) {
    // Clear any existing timeout
    if (acceptProgressTimeoutId) {
      clearTimeout(acceptProgressTimeoutId);
      acceptProgressTimeoutId = null;
    }

    var $resultsModal = $('#autofill-results-modal');

    // Remove any existing progress/error overlays
    $resultsModal.find('.autofill-accept-overlay').remove();
    $resultsModal.find('.autofill-error-alert').remove();

    // Create progress overlay inside the results modal
    var $overlay = $('<div class="autofill-accept-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); z-index: 10; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 20px;">' +
      '<h4 style="margin-bottom: 15px;">Creating Shifts</h4>' +
      '<p id="accept-progress-message" style="margin-bottom: 10px;">' + (message || 'Starting shift creation...') + '</p>' +
      '<div class="progress progress-striped active" style="width: 80%; max-width: 300px; margin: 0;">' +
        '<div id="accept-progress-bar" class="bar" style="width: 0%"></div>' +
      '</div>' +
    '</div>');

    // Ensure modal body has relative positioning for the overlay
    $resultsModal.find('.modal-body').css('position', 'relative').append($overlay);

    // Disable close button and footer buttons
    $resultsModal.find('.modal-header .close').hide();
    $resultsModal.find('.modal-footer button').prop('disabled', true);

    // Set a timeout fallback in case Pusher events never arrive
    acceptProgressTimeoutId = setTimeout(handleAcceptTimeout, ACCEPT_TIMEOUT_MS);
  }

  // Update accept progress bar
  function updateAcceptProgressBar(message, percent) {
    $('#accept-progress-message').text(message);
    $('#accept-progress-bar').css('width', percent + '%');

    // Reset timeout since we're receiving progress updates
    if (acceptProgressTimeoutId) {
      clearTimeout(acceptProgressTimeoutId);
      acceptProgressTimeoutId = setTimeout(handleAcceptTimeout, ACCEPT_TIMEOUT_MS);
    }
  }

  // Handle accept success from Pusher
  function handleAcceptSuccess(data) {
    // Clear timeout fallback
    if (acceptProgressTimeoutId) {
      clearTimeout(acceptProgressTimeoutId);
      acceptProgressTimeoutId = null;
    }

    // Remove the progress overlay
    var $resultsModal = $('#autofill-results-modal');
    $resultsModal.find('.autofill-accept-overlay').remove();

    // Clean up modals
    $resultsModal.remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');

    currentAutofillJobId = null;

    // Show success message and reload
    alert(data.message || 'Shifts created successfully!');
    location.reload();
  }

  // Handle accept failure from Pusher
  function handleAcceptFailure(data) {
    // Clear timeout fallback
    if (acceptProgressTimeoutId) {
      clearTimeout(acceptProgressTimeoutId);
      acceptProgressTimeoutId = null;
    }

    var errorMessage = data.error || 'Unknown error';
    var $resultsModal = $('#autofill-results-modal');

    // Remove the progress overlay
    $resultsModal.find('.autofill-accept-overlay').remove();

    // Re-enable close button and footer buttons
    $resultsModal.find('.modal-header .close').show();
    $resultsModal.find('.modal-footer button').prop('disabled', false);
    $('#accept-autofill-btn').text('Create Shifts');

    // Remove any existing error alert
    $resultsModal.find('.autofill-error-alert').remove();

    // Add error alert at the top of modal body
    var $errorAlert = $('<div class="alert alert-error autofill-error-alert" style="margin-bottom: 15px;">' +
      '<button type="button" class="close" data-dismiss="alert">&times;</button>' +
      '<strong>Failed to create shifts:</strong> ' + errorMessage +
    '</div>');
    $resultsModal.find('.modal-body').prepend($errorAlert);
  }

  // Clean up modals on close
  $(document).on('hidden', '#autofill-modal', function() {
    $(this).remove();
  });

  $(document).on('hidden', '#autofill-results-modal', function() {
    $(this).remove();
  });
});
